import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z" />, 'NearMe');
